<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">進捗情報</span>
      </v-card-title>
      <v-form ref="form" lazy-validation v-model="scheduleValid" value>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <date-input label="書類受付日" v-model="bl.siReleaseDate" />
            </v-flex>
            <v-flex xs3>
              <date-input
                disabled
                required
                label="売上処理日"
                v-model="bl.masterBillConfirmTime"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                disabled
                required
                label="書類完了日"
                v-model="bl.invAttachmentUpdateDate"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="cantEdit"
                required
                label="袋返却日"
                v-model="bl.guaranteedReturnDate"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="cantEdit"
                required
                label="フレイト確認日"
                v-model="bl.shipmentConfirmDate"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="cantEdit"
                required
                label="CLP"
                v-model="bl.containerPackingListDate"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="cantEdit"
                required
                label="カスタムINV"
                v-model="bl.customInvDate"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="cantEdit"
                required
                label="シッピングインストラクション"
                v-model="bl.dateOfShipment"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: ['bl', 'cantEdit'],
  data() {
    return {
      query: {},
      scheduleValid: false,
    }
  },
  methods: {
    updateInvAttachmentDate() {
      this.bl.invAttachmentUpdateDate = this.$today()
    },
  },
}
</script>
